import React from 'react';
import {
  StyleSheet,
  TouchableOpacity,
  View,
} from 'react-native';
import { ODSIcon } from '../ODSIcon';
import { ODSText } from '../ODSText';
import getScreenType from '../../../utils/getScreenType';
import { useTheme } from '@emotion/react';
import { Image } from 'react-native';
import TextAnimator from '../TextAnimator';
import ODSButton from '../ODSButton';
import ODSRentReadyTile from './RentReadyTile';

const ODSWelcomeTile = ({
  title,
  onPress,
  navigationRoutes,
  rentReadyData,
  navigation,
  isActiveOpenflow,
  registerForm,
  loading
}) => {
  console.log("RENT", rentReadyData)
  const theme = useTheme();
  const getItem = (id) => {
    const item = navigationRoutes.find((item) => item.id === id);
    return item;
  };
  const _onFinish = () => {
  }

  const skeletonTitle = () => {
    return (
      <View style={{ marginTop: 24, height: 32, width: 200, backgroundColor: theme.colors.neutral[200], borderRadius: 4 }} />
    )
  }
  const tdsTile = () => {
    return (
      <View style={{ width: '100%', borderRadius: 12, backgroundColor: theme.colors.main.blue[100], padding: 20 }}>
        <View style={{ marginBottom: 8, flexDirection: 'row', justifyContent: 'space-between' }}>
          <Image style={{ width: 64, height: 40 }} source={require("./../../../images/logos/tds.png")} />
          {/* <ODSIcon icon="TB-Tick" size={40} color={theme.colors.elements['color-light']} /> */}
          <Image style={{ width: 34, height: 34 }} source={require("./../../../images/icons/dashboard/tick.png")} />
        </View>
        <ODSText color={theme.colors.text.black} type={'md-bold'}>Deposit is protected!</ODSText>
        {/* <ODSText width={'100%'} marginTop={4} color={theme.colors.text.grey} type={'sm'}>£1,250 secured with TDS</ODSText> */}
        <ODSButton
          type="secondary"
          onPress={onPress}
          restStyle={{ marginTop: 16, width: getScreenType() == 'phone' ? '100%' : '80%' }}
        >
          View Certificate
        </ODSButton>
      </View>
    )
  }
  const tenancyTile = () => {
    return (
      <View style={{ width: '100%', borderRadius: 12, backgroundColor: theme.colors.main.purple[100], padding: 20 }}>
        <ODSText color={theme.colors.text.black} type={'md-bold'}>My Tenancy</ODSText>
        <ODSText width={'100%'} marginTop={8} color={theme.colors.text.grey} type={'sm'}>Your agent has chosen to use tlyfePRO for your move in process. Check your progress and complete actions to help you move into your new property.</ODSText>
        <ODSButton
          type="secondary"
          themeColor={theme.colors.main.purple}
          onPress={onPress}
          restStyle={{ marginTop: 20, width: '100%' }}
        >
          View Progress
        </ODSButton>
      </View>
    )
  }
  const rentReadyTile = () => {
    return (
      <ODSRentReadyTile
        onPress={() => navigation.navigate(getItem('PreQualification').route)}
        rentReadyData={rentReadyData}
      />
    )
  }

  const skeletonTile = () => {
    return (
      <View style={{ width: '100%', height: 200, borderRadius: 12, backgroundColor: theme.colors.other['border-neutral'], padding: 20 }}>
        <View style={{ height: 24, width: '60%', backgroundColor: theme.colors.neutral[300], borderRadius: 4, marginBottom: 16 }} />
        <View style={{ height: 16, width: '100%', backgroundColor: theme.colors.neutral[200], borderRadius: 4, marginBottom: 8 }} />
        <View style={{ height: 16, width: '100%', backgroundColor: theme.colors.neutral[200], borderRadius: 4, marginBottom: 8 }} />
        <View style={{ height: 48, width: '40%', backgroundColor: theme.colors.neutral[300], borderRadius: 8, marginTop: 16 }} />
      </View>
    )
  }

  return (
    <View style={[styles(theme.colors).containerStyle]}>
      {/* <ODSText marginTop={24} color={theme.colors.text.primary} type={'h4'}>
        {title}
      </ODSText> */}
      {loading && !title ? skeletonTitle() : title ? <TextAnimator
        content={title}
        // textStyle={styles.textStyle}
        textStyle={{ color: theme.colors.button.main, fontSize: 26, fontWeight: 'bold' }}
        style={{ marginTop: 24 }}
        timing={700}
        onFinish={_onFinish}
      /> : null}

      <View style={{ marginTop: 12, width: getScreenType() == 'phone' ? '100%' : '80%', paddingVertical: 24, paddingHorizontal: 16, flexDirection: 'row', alignItems: 'center', borderTopWidth: 1, borderTopColor: theme.colors.other['border-neutral'] }}>
        {loading ? skeletonTile() : (isActiveOpenflow ? tenancyTile() : registerForm ? tdsTile() : rentReadyTile())}
      </View>
    </View>
  );
};

const styles = (theme) =>
  StyleSheet.create({
    containerStyle: {
      width: getScreenType() == "phone" ? "96%" : 540,
      borderRadius: 12,
      shadowColor: '#101828',
      shadowOffset: { width: 0, height: 1 },
      shadowOpacity: 0.1,
      shadowRadius: 4,
      elevation: 2,
      backgroundColor: theme.neutral[100],
      paddingHorizontal: 8,
      paddingVertical: 10,
      justifyContent: 'center',
      alignItems: 'center',
      alignSelf: 'center',
      minHeight: 200
    },
  });

export default ODSWelcomeTile;
